import React from 'react';
import AppointmentSummaryPage from './AppointmentSummaryPage';

// Phase 2 & 3 - Dependencies implemented
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import BookAppointmentTimeslotActions from '../../../redux/BookAppointmentTimeslotRedux';
import GetCalendarEventsActions from '../../../redux/GetCalendarEventsRedux';

const AppointmentSummaryPageWrapper: React.FC = () => {
  // Phase 2 & 3 - Navigation implemented
  const navigate = useNavigate();
  const location = useLocation();
  
  // Phase 2 & 3 - Navigation object implemented
  const navigation = {
    goBack: () => navigate(-1),
    getParam: (param: string) => {
      const searchParams = new URLSearchParams(location.search);
      return searchParams.get(param);
    },
    popToTop: () => navigate('/calendar', { replace: true })
  };

  return (
    <AppointmentSummaryPage 
      // Phase 2 & 3 - Props implemented
      navigation={navigation}
      location={location}
    />
  );
};

// Phase 2 & 3 - Redux integration implemented
const mapStateToProps = (state: any) => {
  return {
    children: state.getChildren.children,
    timeslots: state.getAppointmentTimeslots.timeslots,
    categories: state.getAppointmentCategories.categories,
    bookAppointmentTimeslotFetching: state.bookAppointmentTimeslot.fetching,
    bookAppointmentTimeslotSuccess: state.bookAppointmentTimeslot.success,
    bookAppointmentTimeslotError: state.bookAppointmentTimeslot.error,
    bookAppointmentTimeslotStatus: state.bookAppointmentTimeslot.status,
  };
};

// Phase 2 & 3 - Redux integration implemented
const mapDispatchToProps = (dispatch: any) => {
  return {
    bookAppointmentTimeslot: (childId: number, categoryId: number, timeslotId: number) => {
      dispatch(BookAppointmentTimeslotActions.bookAppointmentTimeslotRequest(childId, categoryId, timeslotId));
    },
    getCalendarEvents: () => {
      dispatch(GetCalendarEventsActions.getCalendarEventsRequest());
    }
  };
};

// Phase 2 & 3 - Redux and translations implemented
export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(AppointmentSummaryPageWrapper));
